import ProjectTeaser from './ProjectTeaser.react';
import Project from './Project.react';
import SectionHead from '../section/SectionHead.react';

class Portfolio extends React.Component {

    constructor(props) {
        super(props);

        this.openProject = this.openProject.bind(this);
    }

    openProject(id) {
        console.log('ID', id)
        this.refs.project.show(id);
    }

    render() {
        var self    = this;
        var content = this.props.content;

        return (
            <section
                className='section portfolio'
                id='portfolio'>

                <SectionHead
                    title={content.header.title}
                    subtitle={content.header.subtitle} />

                <div className='row row__100'>

                    { content.details.map(function(details, i) {
                        return (
                            <ProjectTeaser
                                id={i}
                                name={details.id}
                                title={details.title}
                                subtitle={details.subtitle}
                                onClick={self.openProject}
                                key={'project_'+details.id} />
                        );
                    })}

                    <div style={{ 'clear' : 'both' }} />

                </div>

                <Project
                    ref='project'
                    projects={content.details} />

            </section>
        );
    }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/Portfolio.react.jsx